"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventBus_1 = require("./EventBus");
exports.EventBus = EventBus_1.EventBus;
exports.defineEvent = EventBus_1.defineEvent;
exports.createEventDefinition = EventBus_1.createEventDefinition;
//# sourceMappingURL=index.js.map